<template>
    <div class="bg-bhav-cool-gray-50 rounded flex items-stretch overflow-hidden text-sm" :class="$attrs['class']">
        <input
            ref="input"
            :id="getId"
            class="flex-1 p-3 bg-bhav-cool-gray-50 text-bhav-blue-500 focus:outline-none"
            :class="width"
            type="text"
            inputmode="decimal"
            :value="draft"
            @input="onInput"
            @blur="onBlur"
        />
        <span aria-hidden="true" v-if="suffix" class="text-bhav-blue-500 py-3 pr-3">{{ suffix }}</span>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        modelValue: {
            required: true
        },
        suffix: {
            type: [Boolean, String],
            default: false
        },
        width: {
            type: String,
            default: 'w-20'
        },
        min: {
            type: Number,
            default: -Infinity
        },
        max: {
            type: Number,
            default: Infinity
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            draft: this.modelValue !== null && this.modelValue !== undefined ? String(this.modelValue) : ''
        }
    },
    computed: {
        getId() {
            return this.$attrs.id || `coord-field-${this.$.uid}`;
        }
    },
    watch: {
        modelValue(newVal) {
            if (document.activeElement !== this.$refs.input) {
                this.draft = newVal !== null && newVal !== undefined ? String(newVal) : '';
            }
        }
    },
    methods: {
        sanitize(raw) {
            let s = raw.replace(/[^0-9.\-]/g, '');
            const hasMinus = s.startsWith('-');
            s = s.replace(/-/g, '');
            if (hasMinus) s = '-' + s;
            const dotIdx = s.indexOf('.');
            if (dotIdx !== -1) {
                s = s.substring(0, dotIdx + 1) + s.substring(dotIdx + 1).replace(/\./g, '');
            }
            return s;
        },
        onInput(e) {
            const cleaned = this.sanitize(e.target.value);
            this.draft = cleaned;
            if (cleaned !== e.target.value) {
                const cursor = e.target.selectionStart - (e.target.value.length - cleaned.length);
                e.target.value = cleaned;
                e.target.setSelectionRange(cursor, cursor);
            }
        },
        onBlur() {
            const parsed = parseFloat(this.draft);
            if (isNaN(parsed)) {
                this.draft = this.modelValue !== null && this.modelValue !== undefined ? String(this.modelValue) : '';
                return;
            }
            const clamped = Math.min(this.max, Math.max(this.min, parsed));
            this.draft = String(clamped);
            this.$emit('update:modelValue', clamped);
        }
    }
}
</script>
